import { RootState } from '@src/redux/store'
import { prop, propOr } from 'ramda'
import { createSelector } from 'reselect'

import {
  GENERATE_TRANSCRIPT,
  GLOBAL_STATE,
  STUDENT,
  STUDENT_ACHIEVEMENT_RECORDS,
  STUDENT_ALL,
  STUDENT_CONTACT_INFO,
  STUDENT_FULL_INFO,
  STUDENT_GUARD_LIST,
  STUDENT_LIST,
  STUDENT_PERSONAL_INFO,
  STUDENT_PUBLIC_STUDY_PROOF,
  STUDENT_PUBLIC_TRANSCRIPT,
  STUDENT_USERNAME,
} from '../constants/actionTypes'

const studentSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const studentAchievementRecordsSelector = createSelector(
  studentSelectors,
  data => data[STUDENT_ACHIEVEMENT_RECORDS]
)

export const studentAllSelector = createSelector(studentSelectors, data => data[STUDENT_ALL])

export const studentSelector = createSelector(studentSelectors, data => data[STUDENT])

export const studentListSelector = createSelector(studentSelectors, data => data[STUDENT_LIST])

export const studentGuardListSelector = createSelector(studentSelectors, data => data[STUDENT_GUARD_LIST])

export const studentUsernameSelector = createSelector(studentSelectors, data => data[STUDENT_USERNAME])

export const generateTranscriptSelector = createSelector(studentSelectors, data => data[GENERATE_TRANSCRIPT])

export const studentPersonalInfoUpdate = createSelector(studentSelectors, data => data[STUDENT_PERSONAL_INFO])

export const studentFullInfo = createSelector(studentSelectors, data => data[STUDENT_FULL_INFO])

export const studentContactInfoUpdate = createSelector(studentSelectors, data => data[STUDENT_CONTACT_INFO])

export const studentPublicTranscriptSelector = createSelector(studentSelectors, data => data[STUDENT_PUBLIC_TRANSCRIPT])

export const studentPublicStudyProofSelector = createSelector(
  studentSelectors,
  data => data[STUDENT_PUBLIC_STUDY_PROOF]
)

export const studentAllOptionsSelector = createSelector(studentAllSelector, studentAll => {
  return {
    loading: studentAll.loading,
    error: studentAll.error,
    options: Array.isArray(studentAll.data)
      ? studentAll.data.map(item => ({
          label: `${propOr('', 'lastname', item)} ${propOr('', 'firstname', item)} ${propOr('', 'midname', item)}`,
          value: item.id,
        }))
      : [],
  }
})
